export const CHANNEL_VIDEO_PREFIX = 'channel-video-';
export const denormalizeChannelVideoId = id => id ? `${CHANNEL_VIDEO_PREFIX}${id}` : id;
export const normalizeChannelVideoId = id => id ? id.replace(CHANNEL_VIDEO_PREFIX, '') : id;
export const isChannelVideo = video => Boolean(video && video.id && video.id.startsWith(CHANNEL_VIDEO_PREFIX));
//# sourceMappingURL=channel-video-utils.js.map